import Vue from 'vue'
import SlotMachineOption from './slotMachine.vue'

const SlotMachine = Vue.extend(SlotMachineOption)

export function templateSlotMachineVue({ module, postMessage, callModule }) {
  const slotMachine = new SlotMachine({
    propsData: {
      module
    },
    methods: {
      postMessage,
      callModule
    }
  }).$mount()
  return slotMachine.$el
}
